<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Instrutores">
                  <FormInstrutor></FormInstrutor>
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
import FormInstrutor from './FormInstrutor'
export default {
  name: 'form-instrutor-edicao',
  components: {
    FormInstrutor
  }
}
</script>
